import {homepageBannerSideBarNav} from "./CHILDREN-SIDEBARNAV";

export default [
    {
        _name: 'CSidebarNav',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: 'Dashboard',
                to: '/dashboard',
                icon: 'cil-speedometer',
                badge: {
                    color: 'primary',
                    text: 'NEW'
                }
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Feature']
            },
            homepageBannerSideBarNav,
            {
                _name: "CSidebarNavItem",
                name: "Banner List",
                to: "/management/banner-list",
                icon: "cil-laptop"
            },
            {
                _name: "CSidebarNavItem",
                name: "Meta Info",
                to: "/management/meta-info",
                icon: "cil-cursor"
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Program',
                to: '/management/program',
                icon: 'cil-layers'
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "Event & Tips",
                to: "/management/corporate",
                icon: 'cil-layers',
                items: [
                    {
                        name: 'Event & Tips',
                        to: "/management/corporate",
                    },
                    {
                        name: 'Hashtag',
                        to: '/management/corporate-hashtag'
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'About Us',
                route: '/about-us',
                icon: 'cil-star',
                items: [
                    {
                        name: 'Press Release',
                        to: '/about-us/press-release'
                    },
                ]
            },
            {
                _name: "CSidebarNavItem",
                name: "Product",
                to: "/management/product",
                icon: "cil-layers"
            },
        ]
    }
]

